export const paginationComponentOptions = {
  rowsPerPageText: "Raðir á síðu",
  rangeSeparatorText: "af ",
  selectAllRowsItemText: "Allt",
  selectAllRowsItem: true,
};
